import { combineReducers } from 'redux';

import themeReducer from './reducers/theme.reducer';
import layoutReducer from './reducers/layout.reducer';
import imageEle from './reducers/imgElement.reducer';
import textEle from './reducers/textElement.reducer';
import userProfileReducer from './reducers/userProfile/index';
import desinerReducer from './reducers/designer.reducer';

// Combine with other reducers we may add in the future
const todoApp = combineReducers({
  theme: themeReducer,
  layout: layoutReducer,
  imageEle,
  textEle,
  userProfile: userProfileReducer,
  designer: desinerReducer
});

export default todoApp;



// WEBPACK FOOTER //
// ./src/reducers.js